/**
 *  Modal
 *  v1.0
 *  Onepixel - shess
 *  august 2020
 *  @need _modals.scss component
 */

const modalBody = document.querySelector('body');
var modals = document.querySelectorAll('.js-modal');

if (modals.length) {

  // open btns
  var openbtns = document.querySelectorAll('.js-modalOpen');
  for (let i = 0; i < openbtns.length; i++) {
    openbtns[i].addEventListener('click', function (event) {
      event.preventDefault()
      const modalId = this.getAttribute('data-modal')
      openModal(modalId)
    })
  }

  //close btns
  var closebtns = document.querySelectorAll('.js-modalClose')
  for (let i = 0; i < closebtns.length; i++) {
    closebtns[i].addEventListener('click', closeModal)
  }

  // overlay
  let overlay = document.querySelector('.js-modalOverlay')
  overlay.addEventListener('click', closeModal)

  // esc key
  document.onkeydown = function (evt) {
    evt = evt || window.event
    var isEscape = false
    if ('key' in evt) {
      isEscape = (evt.key === 'Escape' || evt.key === 'Esc')
    } else {
      isEscape = (evt.keyCode === 27)
    }
    if (isEscape && document.body.classList.contains('js-modalActive')) {
      closeModal()
    }
  };
}

// open modal
function openModal(modalId) {
  const modal = document.querySelector(`.js-modal${modalId}`)

  modal.classList.remove('opacity-0')
  modal.classList.remove('pointer-events-none')
  modalBody.classList.add('js-modalActive')
  // focus sur le champ de recherche
  if( modalId === 'quicksearch' ){
    const search_input = document.getElementById('search-input')
    search_input.focus()
  }

}

// close modal
function closeModal() {
  for (let i = 0; i < modals.length; i++) {
    modals[i].classList.add('opacity-0')
    modals[i].classList.add('pointer-events-none')
  }
  modalBody.classList.remove('js-modalActive')
}



// WEBPACK FOOTER //
// ./scripts/autoload/modal.js